var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../form.html"] = require( "../form.html" );
dependencies["../../elements/combobox.html"] = require( "../../elements/combobox.html" );




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/modals/modalMailSend.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../form.html", false, "views/content/modals/modalMailSend.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("form", t_1);
output += "\r\n";
env.getTemplate("../../elements/combobox.html", false, "views/content/modals/modalMailSend.html", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("combo", t_4);
output += "\r\n\r\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ModalSendMailTitle")) {
output += "\r\n\t<div class=\"modal-header\">\r\n\t\t<h4 class=\"modal-title\" id=\"modalLable\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),4), env.opts.autoescape);
output += " - ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ModalSendMailTitle"), env.opts.autoescape);
output += "</h5>\r\n\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\r\n\t\t\t<span aria-hidden=\"true\">&times;</span>\r\n\t\t</button>\r\n\t</div>\r\n";
;
}
output += "\r\n<form class=\"grid ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "simple")?"simple":""), env.opts.autoescape);
output += "\" id=\"modalMailSend\">\r\n    <div class=\"modal-body\">\r\n\r\n        <div class=\"container-fluid\">\r\n        <div id=\"notifyDialog\" style=\"display:none;\" class=\"alert alert-warning alert-dismissible fade show\" role=\"alert\">\r\n            <span id=\"notifyDialogContent\"></span>\r\n            <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">\r\n                <span aria-hidden=\"true\">&times;</span>\r\n            </button>\r\n        </div>\r\n            \r\n            ";
if(runtime.contextOrFrameLookup(context, frame, "type") != "dialog") {
output += "\r\n                <img src=\"/App_Themes/images/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
output += ".svg\">\r\n            ";
;
}
output += "\r\n            ";
if(runtime.contextOrFrameLookup(context, frame, "args") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")) {
output += "\r\n                <div class=\"row\">\r\n                    <div class=\"col col-lg-4 col-sm-12 list-contacts\" style=\"height: 100%;\">\r\n                        <input type=\"hidden\" name=\"PrimaryKeyValue\" class=\"form-control\" value=";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),4), env.opts.autoescape);
output += ">\r\n                        <input type=\"hidden\" name=\"Subject\" class=\"form-control\" value=";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),5)),"Subject"), env.opts.autoescape);
output += ">\r\n                        <input type=\"hidden\" name=\"PrimaryKey\" class=\"form-control\" value=";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),6)),"PrimaryKey"), env.opts.autoescape);
output += ">\r\n                        <!-- test fields -->\r\n                        <div class=\"col\">\r\n                            <label class=\"form-field\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),3)),"Type") == "Boolean") {
output += " style=\"display: flex; justify-content: center;\" ";
;
}
output += ">\r\n                                <div class=\"form-label text-left\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"modalMailSendAddContact"), env.opts.autoescape);
output += "</div>\r\n                                <div class=\"form-input required-field ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),3)),"Type") == "Money"?"money":""), env.opts.autoescape);
output += "\">\r\n                                    ";
var t_7;
t_7 = runtime.contextOrFrameLookup(context, frame, "null");
frame.set("initialValue", t_7, true);
if(frame.topLevel) {
context.setVariable("initialValue", t_7);
}
if(frame.topLevel) {
context.addExport("initialValue", t_7);
}
output += "\r\n                                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),3)),"Initial")) {
output += "\r\n                                        ";
var t_8;
t_8 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),3)),"Initial")),"Value");
frame.set("initialValue", t_8, true);
if(frame.topLevel) {
context.setVariable("initialValue", t_8);
}
if(frame.topLevel) {
context.addExport("initialValue", t_8);
}
output += "\r\n                                    ";
;
}
output += "\r\n                                    ";
output += runtime.suppressValue((lineno = 40, colno = 58, runtime.callWrap(runtime.memberLookup((t_1),"createInputField"), "form[\"createInputField\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),3),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),3)),"Type"),runtime.contextOrFrameLookup(context, frame, "initialValue"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),3)),"Initial"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "window")])), env.opts.autoescape);
output += "\r\n                                </div>\r\n                            </label>\r\n                        </div>\r\n                        <div class=\"col\">\r\n                            <label class=\"form-field\">\r\n                                <div class=\"form-label text-left\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"modalMailSendAddEmail"), env.opts.autoescape);
output += "</div>\r\n                                <div class=\"form-input required-field ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),0)),"Type") == "Money"?"money":""), env.opts.autoescape);
output += "\">\r\n                                    ";
var t_9;
t_9 = runtime.contextOrFrameLookup(context, frame, "null");
frame.set("initialValue", t_9, true);
if(frame.topLevel) {
context.setVariable("initialValue", t_9);
}
if(frame.topLevel) {
context.addExport("initialValue", t_9);
}
output += "\r\n                                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),0)),"Initial")) {
output += "\r\n                                        ";
var t_10;
t_10 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),0)),"Initial")),"Value");
frame.set("initialValue", t_10, true);
if(frame.topLevel) {
context.setVariable("initialValue", t_10);
}
if(frame.topLevel) {
context.addExport("initialValue", t_10);
}
output += "\r\n                                    ";
;
}
output += "\r\n                                    <div class=\"form-group mb-3\">\r\n                                        <input type=\"email\" name=\"mailAddress\" class=\"form-control\" aria-label=\"addEmailAddress\" aria-describedby=\"addEmailAddressButton\">\r\n                                    </div>\r\n                                </div>\r\n                            </label>\r\n                        </div>\r\n                        <!-- START List with selected contacts or email addresses -->\r\n                        <div class=\"col\">\r\n                            <ul id=\"emailToList\">\r\n                            </ul>\r\n                        </div>\r\n                        <!-- END List with selected contacts or email addresses -->\r\n                    </div>\r\n                    <div class=\"col col-lg-8 col-sm-12\">\r\n                        <div class=\"col col-xs-12\">\r\n                            <label class=\"form-field\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),2)),"Type") == "Boolean") {
output += " style=\"display: flex; justify-content: center;\" ";
;
}
output += ">\r\n                                <div class=\"form-label text-left\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"modalMailSendReportTemplateLabel"), env.opts.autoescape);
output += "</div>\r\n                                <div class=\"form-input required-field ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),1)),"Type") == "Money"?"money":""), env.opts.autoescape);
output += "\">\r\n                                    ";
var t_11;
t_11 = runtime.contextOrFrameLookup(context, frame, "null");
frame.set("initialValue", t_11, true);
if(frame.topLevel) {
context.setVariable("initialValue", t_11);
}
if(frame.topLevel) {
context.addExport("initialValue", t_11);
}
output += "\r\n                                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),1)),"Initial")) {
output += "\r\n                                        ";
var t_12;
t_12 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),1)),"Initial")),"Value");
frame.set("initialValue", t_12, true);
if(frame.topLevel) {
context.setVariable("initialValue", t_12);
}
if(frame.topLevel) {
context.addExport("initialValue", t_12);
}
output += "\r\n                                    ";
;
}
output += "\r\n                                    ";
output += runtime.suppressValue((lineno = 74, colno = 58, runtime.callWrap(runtime.memberLookup((t_1),"createInputField"), "form[\"createInputField\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),1),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),1)),"Type"),runtime.contextOrFrameLookup(context, frame, "initialValue"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),1)),"Initial"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "window")])), env.opts.autoescape);
output += "\r\n                                </div>\r\n                            </label>\r\n                        </div>\r\n                        <div class=\"col col-xs-12\">\r\n                            <label class=\"form-field\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),2)),"Type") == "Boolean") {
output += " style=\"display: flex; justify-content: center;\" ";
;
}
output += ">\r\n                                <div class=\"form-label text-left\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"modalMailSendMailTemplateLabel"), env.opts.autoescape);
output += "</div>\r\n                                <div class=\"form-input required-field ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),2)),"Type") == "Money"?"money":""), env.opts.autoescape);
output += "\">\r\n                                    ";
var t_13;
t_13 = runtime.contextOrFrameLookup(context, frame, "null");
frame.set("initialValue", t_13, true);
if(frame.topLevel) {
context.setVariable("initialValue", t_13);
}
if(frame.topLevel) {
context.addExport("initialValue", t_13);
}
output += "\r\n                                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),2)),"Initial")) {
output += "\r\n                                        ";
var t_14;
t_14 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),2)),"Initial")),"Value");
frame.set("initialValue", t_14, true);
if(frame.topLevel) {
context.setVariable("initialValue", t_14);
}
if(frame.topLevel) {
context.addExport("initialValue", t_14);
}
output += "\r\n                                    ";
;
}
output += "\r\n                                    ";
output += runtime.suppressValue((lineno = 86, colno = 58, runtime.callWrap(runtime.memberLookup((t_1),"createInputField"), "form[\"createInputField\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),2),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),2)),"Type"),runtime.contextOrFrameLookup(context, frame, "initialValue"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "args")),"fields")),2)),"Initial"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "window")])), env.opts.autoescape);
output += "\r\n                                </div>\r\n                            </label>\r\n                        </div>\r\n                    \r\n\r\n                        <div class=\"col col-xs-12\">\r\n                            <label class=\"form-field fluid-height dirty\">\r\n                                <div class=\"form-label\" title=\"Content\">\r\n                                    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"modalMailSendMailDescriptionLabel"), env.opts.autoescape);
output += "\r\n                                </div>\r\n                                <div class=\"form-input \">\r\n                                <div name=\"mailTemplate\" id=\"mailTemplate\" class=\"editable-text\" contenteditable=\"true\" style=\"max-height:250px; min-height: 250px; max-height: 250px; overflow: overlay;\" data-html-editor></div>\r\n                                </div>\r\n                            </label>\r\n                        </div>\r\n\r\n                    </div>\r\n                    \r\n                    \r\n                </div>\r\n                <!--/row-->\r\n\r\n            ";
;
}
else {
output += "\r\n                ";
if(runtime.contextOrFrameLookup(context, frame, "type") == "choice") {
output += "\r\n                <select name=\"choice\">\r\n                    ";
frame = frame.push();
var t_17 = runtime.contextOrFrameLookup(context, frame, "args");
if(t_17) {var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("option", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
output += "\r\n                    <option>";
output += runtime.suppressValue(t_18, env.opts.autoescape);
output += "</option>\r\n                    ";
;
}
}
frame = frame.pop();
output += "\r\n                </select>\r\n                ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "type") == "date") {
output += "\r\n                    <div class=\"date-picker\">\r\n                        <input type=\"text\" name=\"givendate\" autocomplete=\"no\" class=\"editable-text date\">\r\n                    </div>\r\n                ";
;
}
;
}
output += "\r\n            ";
;
}
output += "\r\n        </div>\r\n        <!-- /container -->\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n        <div class=\"msg-actions text-\">\r\n            \r\n            <button class=\"btn btn-primary button-menu mr-auto\" type=\"submit\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ModalSendMailTitle"), env.opts.autoescape);
output += "</button>\r\n        </div>\r\n    </div>\r\n</form>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/modals/modalMailSend.html"] , dependencies)